import React, { useState, useEffect, useContext } from "react";
import { NavigateWayContext } from '../store/NavigateWayContext';
import { useGlobalState } from '../store/useGlobalState';
import { Button } from "../components/button/button";
import { Header } from "../components/header/header";
import { Search } from "../components/search/search";
import edit from "../img/edit.svg";
import newRoomIcon from "../img/newRoom.svg";
import "../styles/addDc.css";
import { useNavigate, useParams } from "react-router-dom";
import chevron from "../img/chevron.svg";
import { Input } from "../components/input/input";
import deleteRow from '../img/deleteRow.svg'
import axiosInstance from "../auth/axiosInstance";
import FooterStatus from "../components/footerStatus/footerStatus";
import ModalSuccessFail from "../components/ModalConfirm/ModalConfirm";
import ModalSucesso from "../components/ModalSucesso/index";
import ModalEditRoom from "../components/modalEditRoom/modalEditRoom";
import { useMsal } from "@azure/msal-react";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";

function Room({ type }) {
  const param = useParams();
  const [showEdit, setShowEdit] = React.useState(false);
  const [editText, setEditText] = React.useState(false);
  const navigate = useNavigate();
  const [showFeedback, setShowFeedback] = React.useState(false);
  const [values, setValues] = React.useState({});
  const [initialData, setInitialData] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [openModal, setOpenModal] = React.useState({ id: 0, show: false });
  const [status, setStatus] = React.useState(false);
  const [content, setContent] = React.useState("");
  const [fileiras, setFileiras] = React.useState([]);

  const [name, setName] = useState('')
  const [projectedRacks, setProjectedRacks] = useState(0)

  {/*    
      Mechanical Load Available = mechanical_energy - capacidade de energia da sala       
      Contracted Electrical Load = contracted_energy - total de energia contratada no datahall
      Current Electrical Load = current_energy - total de energia consumida no datahall
      Cooling Electrical Load = cooling_energy - total de energia reservada para refrigaração
  */}
  const [mechanicalEnergy, setMechanicalEnergy] = useState(null)
  const [contractedEnergy, setContractedEnergy] = useState(null)
  const [currentEnergy, setCurrentEnergy] = useState(null)
  const [coolingEnergy, setCoolingEnergy] = useState(null)

  const [deleteDH, setDeleteDH] = useState('');

  const { navigateWay, setNavigateWay } = useContext(NavigateWayContext);
  // navigateWay = {site: '/', room: '', rack: '', map: '', newcount: '', diagram: ''}

  useEffect(() => {
    setNavigateWay(prevState => ({
      ...prevState,
      room: `/room/${param.dc}/${param.id}`
    }));
  }, [])

  function getData() {
    axiosInstance(`room/site/${param.id}`)
      .then((res) => {
        setData(res.data);
        setInitialData(res.data);
      })
      .catch((err) => console.log(err));
  }

  const racks = (number) => {
    setFileiras([...fileiras, number])
  }

  function newRoom(event) {
    event.preventDefault();
    const index = parseInt(projectedRacks);
    values["room"] = name;
    values["projectedRacks"] = index;
    values["site_id"] = param.id;
    values["mechanical_energy"] = mechanicalEnergy;
    values["contracted_energy"] = contractedEnergy;
    values["current_energy"] = currentEnergy;
    values["cooling_energy"] = coolingEnergy;

    axiosInstance.post("room", values).then((res) => {
      if (res.status === 201) {
        postLog(`Data Hall ${values.room} created`)
        setShowEdit(false);
        getData();
        setTimeout(() => {
          setShowFeedback(false);
        }, 10000);
        setShowFeedback(true);
        setValues({});
      }
    })
    .catch((err) => {
      console.log(err);
      setContent("Error on updating status");
      setStatus(true);
    });
  }

  function getRoomById(id) {
    axiosInstance(`room/${id}`)
      .then((res) => {
        if (res.status === 200) {
          getData();
          setValues(res.data);
          setName(res.data.room);
          setProjectedRacks(res.data.projectedRacks);
          setMechanicalEnergy(res.data.mechanical_energy)
          setContractedEnergy(res.data.contracted_energy)
          setCurrentEnergy(res.data.current_energy)
          setCoolingEnergy(res.data.cooling_energy)
        }
      })
      .catch((err) => console.log(err));
  }

  function putRoom(e, id) {
    e.preventDefault();
    const index = parseInt(projectedRacks);

    let obj = {
      room: name,
      projectedRacks: index,
      mechanical_energy: mechanicalEnergy,
      contracted_energy: contractedEnergy,
      current_energy: currentEnergy,
      cooling_energy: coolingEnergy
    };
    axiosInstance
      .patch(`room/${id}`, obj)
      .then((res) => {
        if (res.status === 200) {
          postLog(`Data Hall ${name} updated`)
          getData();
          setTimeout(() => {
            setShowFeedback(false);
          }, 10000);
          setShowFeedback(true);
          setShowEdit(false);
          setValues({});
        }
      })
      .catch((err) => console.log(err));
  }

  function delRoom(id) {
    axiosInstance
      .delete(`room/${id}`)
      .then((res) => {
        if (res.status === 200) {
          postLog(`Data Hall ${values.room} deleted`)
          setOpenModal({ id: 0, show: false });
          getData();
          setTimeout(() => {
            setShowFeedback(false);
          }, 10000);
          setShowFeedback(true);
          setValues({});
          setShowEdit(false);
        }
      })
      .catch((err) => {
        console.log(err)
        setOpenModal({ id: 0, show: false })
        setContent("Cannot delete the data hall, one or more racks are still connected to it!");
        setStatus(true);
      });
  }

  function putInFinal() {
    setTimeout(() => {
      const putInFinal = document.getElementById('dynamic-content-table');
      putInFinal.scrollTo({
        left: putInFinal.scrollWidth,
        behavior: 'smooth'
      });
    }, 50);
  }

  const { accounts } = useMsal()

  function postLog(text) {
    axiosInstance.post('logs', {
      email: accounts[0].username,
      name: accounts[0].name,
      action: text
    })
      .catch(err => console.log(err))
  }

  React.useEffect(() => {
    getData();
  }, []);





  return (
    <section className="control-body">
      <Header line>
        <Breadcrumb
          site={true}
          room={false}
          map={false}
          newcount={false}
          diagram={false}
        />
      </Header>

      <div className="search-area">
        <Search
          initialData={initialData}
          set={setData}
          style={{
            border: "1px solid #0F0742",
            boxShadow: "0 0 0",
            width: type !== 'View Only' ? "75%" : '100%',
          }}
          placeholder="Search DH"
        />
        {type !== 'View Only' && <Button
          style={{ width: "30%", background: "#0F0742", color: "#fff" }}
          onClick={() => {
            setShowEdit(true);
            return setEditText(false);
          }}
          label={"New DH"}
          icon={newRoomIcon}
        />}
      </div>
      <h1 className="title-totalracks">Total DH ({data.length})</h1>
      <section className="table-estructure-rack">
        {data.map((value) => {
          return (
            <div className="row-table-estructure">
              <div className="column-table-estructure">
                <h1>Data Hall</h1>
                <h3
                  style={{
                    color:"#fff",
                    fontWeight:"500",
                    fontSize:"1rem",
                    background: '#7896A7',
                    width:"200px",
                    maxWidth: "140%",
                  }}
                  className="style-list-room-table-dc"
                >
                  {value.room}
                </h3>
              </div>
              <div style={{ width: '6vw' }} className="column-table-estructure">
                <h1>Projected Racks</h1>
                <h3>{value.projectedRacks}</h3>
              </div>
              <div style={{ width: '0.5vw' }} className="column-table-estructure">
                <h1>Racks</h1>
                <h3>{value.totalRacks}</h3>
              </div>

              <div style={{ width: '5vw' }} className="column-table-estructure">
                <h1>Projected IT Load</h1>
                <h3>{value.mechanical_energy == undefined ? 'N/A' : value.mechanical_energy}</h3>
              </div> 

              <div style={{ width: '3vw' }} className="column-table-estructure">
                <h1>Cooling Load</h1>
                <h3>{value.cooling_energy  == undefined ? 'N/A' : value.cooling_energy}</h3>
              </div>

              <div style={{ width: '5vw' }} className="column-table-estructure">
                <h1>Contracted Load</h1>
                <h3>{value.contracted_energy  == undefined ? 'N/A' : value.contracted_energy}</h3>
              </div> 

              <div style={{ width: '5vw' }} className="column-table-estructure">
                <h1>Measured Charge</h1>
                <h3>{value.current_energy  == undefined ? 'N/A' : value.current_energy}</h3>
              </div> 

              <div style={{ width: '4vw' }} className="column-table-estructure">
                <h1>Available Load</h1>
                <h3>{value.cooling_energy  == undefined ? 'N/A' : value.mechanical_energy - value.contracted_energy}</h3>
              </div>

              <div style={{ width: '7vw' }} className="column-table-estructure">
                <h1>Limite Load</h1>
                <h3
                  style={
                    (value.contracted_energy / value.mechanical_energy) * 100 >= 80 &&
                    (value.contracted_energy / value.mechanical_energy) * 100 <= 89 ?
                    {color:'orange', fontWeight:'bold'}
                    : (value.contracted_energy / value.mechanical_energy) * 100 >= 90 ? 
                    {color:'red', fontWeight:'bold'}
                    : {color:'#00838D', fontWeight:'bold'}
                  }
                >
                  {
                    value.contracted_energy == undefined || value.cooling_energy == undefined || value.mechanical_energy == 0 ? 'N/A' :
                    ((value.contracted_energy / value.mechanical_energy) * 100).toFixed(2) + ' %'
                  }
                </h3>
              </div> 


              <div className="content-view-room">
                {/* {
                  type !== 'View Only' ?
                    <img
                      onClick={() => {
                        setShowEdit(true);
                        setEditText(true);
                        setDeleteDH(value.id)
                        return getRoomById(value.id);
                      }}
                      src={edit}
                      alt="edit"
                    />
                  :
                    <></>
                } */}
                <img
                  onClick={() => {
                    setShowEdit(true);
                    setEditText(true);
                    setDeleteDH(value.id)
                    return getRoomById(value.id);
                  }}
                  src={edit}
                  alt="edit"
                />


                <div className="btn-dh-dashboard btn-ajuste-dh"
                  onClick={(async) => (
                    setNavigateWay(prevState => ({
                      ...prevState,
                      rack: `/details/${value.id}/${value.room}/all`
                    })),
                    setTimeout(() => {
                      navigate(`/details/${value.id}/${value.room}/all`)
                    }, 100)
                  )}
                >
                  <img
                    style={{transform: 'rotate(90deg)', marginBottom:'-2px'}}
                    src={chevron}
                    alt="Select Data Hall"
                  />
                </div>
                
              </div>

            </div>
          );
        })}
      </section>

      {/* CARD NEW AND EDIT ROOM */}
      <ModalEditRoom
        show={showEdit}
        close={() => { setShowEdit(false); setDeleteDH(''); return setValues({}) }}
        hidenDelete={false}
        deleteDH={() => setOpenModal({ id: deleteDH, show: true })}
        label={`${editText
          ? "Insert the information below to edit a DH"
          : "Insert the information below to register a new DH"
          }`}
        title={`${editText ? "Edit DH" : "New DH"}`}
        labelButton={`${editText ? "Edit" : "Add"}`}
        iconButton={newRoomIcon}
        function={editText ? (e) => putRoom(e, values.id) : (e) => newRoom(e)}
        styleButton={
          Object.keys(values).length < 0 ? { cursor: "not-allowed", backgroundColor: '#ccc' } : {}
        }
        disabled={Object.keys(values).length < 0}
      >
        <section className="content-select-room">

          {/* ROOM NAME / TOTAL PROJECTED RACKS */}
          <div style={{ display: 'grid', alignItems: 'center', width: '100%', gap: 20, gridTemplateColumns: 'repeat(3, 1fr)' }}>
            <Input value={param.dc} props={{ border: 'none', background: 'transparent', minWidth: 0 }} disabled title="Data Center" />
            <Input
              onChange={(event) => setName(event.target.value)}
              placeholder="Insert Here"
              value={name}
              name="room"
              props={{ minWidth: 0 }}
              required={!editText}
              title="Data Hall"
            />
            <Input
              onChange={(event) => setProjectedRacks(event.target.value)}
              placeholder="0"
              props={{ minWidth: 0 }}
              name="projectedRacks"
              value={projectedRacks}
              type='number'
              required={!editText}
              title="Total Projected Racks"

            />
          </div>


          {/*
            CAPACIDADE DE ENERGIA TOTAL
            Projected IT Load = mechanical_energy
            const [mechanicalEnergy, setMechanicalEnergy] = useState(0)
          */}
          <div style={{ display: 'grid', alignItems: 'center', width: '100%', gap: 20, gridTemplateColumns: 'repeat(3, 1fr)' }}>
            <Input
              onChange={(event) => setMechanicalEnergy(event.target.value)}
              placeholder="Insert Here"
              value={mechanicalEnergy}
              name="room"
              props={{ minWidth: 0 }}
              required={!editText}
              type='number'
              title="Projected IT Load"
            />
          </div>

          {/*    
            ENERGIA CONTRATADA TOTAL PELOS CLIENTES NO DATAHALL
            Contracted Electrical Load = contracted_energy
            const [contractedEnergy, setContractedEnergy] = useState(0)
          */}
          <div style={{ display: 'grid', alignItems: 'center', width: '100%', gap: 20, gridTemplateColumns: 'repeat(3, 1fr)' }}>
            <Input
              onChange={(event) => setContractedEnergy(event.target.value)}
              placeholder="Insert Here"
              value={contractedEnergy}
              name="room"
              props={{ minWidth: 0 }}
              required={!editText}
              type='number'
              title="Contracted Electrical Load"
            />
          </div>

          {/*    
            ENERGIA CONSUMIDA TOTAL PELOS CLIENTES NO DATAHALL
            Measured Charge = current_energy
            const [currentEnergy, setCurrentEnergy] = useState(0)
          */}
          <div style={{ display: 'grid', alignItems: 'center', width: '100%', gap: 20, gridTemplateColumns: 'repeat(3, 1fr)' }}>
            <Input
              onChange={(event) => setCurrentEnergy(event.target.value)}
              placeholder="Insert Here"
              value={currentEnergy}
              name="room"
              props={{ minWidth: 0 }}
              required={!editText}
              type='number'
              title="Measured Charge"
            />
          </div>

          {/*    
            ENERGIA RESERVADA TOTAL PARA COOLING NO DATAHALL
            Cooling Electrical Load = cooling_energy
            const [coolingEnergy, setCoolingEnergy] = useState(0)
          */}
          <div style={{ display: 'grid', alignItems: 'center', width: '100%', gap: 20, gridTemplateColumns: 'repeat(3, 1fr)' }}>
            <Input
              onChange={(event) => setCoolingEnergy(event.target.value)}
              placeholder="Insert Here"
              value={coolingEnergy}
              name="room"
              props={{ minWidth: 0 }}
              required={!editText}
              type='number'
              title="Cooling Electrical Load"
            />
          </div>

        </section>
      </ModalEditRoom >


      <FooterStatus
        show={showFeedback}
        cancel={() => setShowFeedback(false)}
        text={`Action done successfully, you can see on this page and others.`}
      />

      <div style={openModal.show == true ? { display: "flex" } : { display: "none" }}>
        <ModalSuccessFail
          yes={() => delRoom(openModal.id)}
          no={() => setOpenModal({ id: 0, show: false })}
          content={"Are you sure you want to delete this room?"}
        />
      </div>

      <ModalSucesso
        status={status}
        content={content}
        ok={() => setStatus(false)}
      />
    </section >
  );
}

export default Room;
